import raMessages from 'ra-language-english';

const fields = {
  names: {
    last_name: 'Last Name',
    first_name: 'First Name',
  },
  password: {
    initial_password: 'Initial Password',
    password: 'New Password',
    password_confirm: 'Confirm Password',
    password_reset: 'Password Reset',
  },
  times: {
    created_at: 'Created At',
    updated_at: 'Last Updated',
    deleted_at: 'Deleted At',
    first_login: 'Initial Login',
    last_login: 'Last Login',
  },
  lesson_groups: {
    lesson_group_ids: 'Lesson Group',
    lesson_group_names: 'Lesson Group Name',
    lesson_group_ids_assigned: 'Lesson Group Assigned',
  }
}

const domainMessages = {
  resources: {
    labels: {
      ...fields.times,
      profile: 'Profile',
      management: 'Manage',
      password: 'Password',
      system: 'System Information',
      history: 'History',
      password_reset: 'Password Reset',
    },
    schools: {
      name: 'School Information',
      fields: {
        name: 'School Name',
        address: 'School Address',
        classification: 'School Classification',
        max_supervisors: 'Max Teachers',
        max_players: 'Max Students',
      }
    },
    supervisors: {
      name: 'Manage Teachers',
      fields: {
        ...fields.names,
        ...fields.password,
        ...fields.lesson_groups,
        role: 'Privilege',
      },
      button: {
        transfer_owner: 'Transfer Ownership',
      }
    },
    players: {
      name: 'Manage Students',
      fields: {
        ...fields.names,
        ...fields.password,
        ...fields.lesson_groups,
        grade: 'Grade',
        school_class: 'Class',
        student_id: 'Student ID',
        login_id: 'Login ID',
        cleared_chapters: 'Status',
        file: 'File',
        restore: 'Restore',
        show_deleted: 'Show deleted',
      }
    },
    lesson_groups: {
      name: 'Manage Lesson Group',
      fields: {
        name: 'Name',
        supervisors_count: 'Number of Enrolled Teachers',
        players_count: 'Number of Enrolled Students',
      }
    },
    profiles: {
      fields: {
        ...fields.password,
      },
    },
    student_files: {
      name: 'Students',
      notes: {
        note1: 'Create a file with comma-delimited CSV.',
        note2: 'The first line is a header line and will not be imported.',
        note3: 'The contents of each column are as follows:',
        multi: 'Multiple columns',
      },
    },
    errors: {
      password_mismatch: 'Password does not match',
      email_already_exists: 'Email already exists',
      email_mismatch: 'Mail Address does not match',
    },
    messages: {
      delete_title: "Delete %{name}",
      transfer_owner: {
        title: 'Transfer Ownership',
        content: "Are sure you want to give %{name} ownership privilege?",
      },
      password_reset: {
        success: 'Password reset completed',
        send: 'The account information has been sent to the email address.',
      }
    },
  },
  ra: {
    ...raMessages.ra,
    action: {
      ...raMessages.ra.action,
      export: "CSV Export",
      import: "CSV Import",
      send: "Send",
    },
    auth: {
      ...raMessages.ra.auth,
      email: 'Mail Address',
      input_new_password: 'Input a new password',
      password_reset: 'Click here if you forgot your password',
      email_confirm: 'Confirm Mail Address',
    },
    page: {
      ...raMessages.ra.page,
      empty: '%{name} No data to display',
      invite: '',
    },
    notification: {
      ...raMessages.ra.notification,
      transfer_owner_completed: 'Ownership has transferred.',
      send: 'Sent',
    }
  }
};

export default {
  ...raMessages,
  ...domainMessages
};
